module.exports = __webpack_public_path__ + "static/media/chess-queen-alt.2f6a621b.svg";